'use client'

import { useComponentTranslation } from '@tebuto/functions/translation.components'
import { CheckoutButton } from '@tebuto/payment/checkout/CheckoutButton'

interface StripeCheckoutSessionReloadPromptProps {
    message: string
    onReload: () => void
    isReloading: boolean
    testId?: string
}

export function StripeCheckoutSessionReloadPrompt({
    message,
    onReload,
    isReloading,
    testId
}: StripeCheckoutSessionReloadPromptProps) {
    const { t } = useComponentTranslation()

    return (
        <div className="flex flex-col gap-3" data-testid={testId}>
            <p className="text-sm text-red-600">{message}</p>
            <CheckoutButton
                type="button"
                data-testid="booking-payment-reload-checkout-session"
                onClick={onReload}
                disabled={isReloading}
                isLoading={isReloading}
                className="min-h-11 text-base"
            >
                {t('booking.payment.reloadCheckoutSession')}
            </CheckoutButton>
        </div>
    )
}
